import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '@shared/ui';
import { AuthPromoPane } from './AuthPromoPane';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const { t } = useTranslation();
  return (
    <div className="grid h-dvh w-full grid-cols-1 overflow-hidden bg-base nav:grid-cols-2">
      {/* Низкий экран телефона (браузер Instagram — около 560 px): отступы меньше, чтобы кнопка формы была видна без
          прокрутки (владелец 2026-10-30: из Instagram ушли с формы, кнопка была за нижним краем). */}
      <div className="flex h-dvh flex-col items-center justify-between gap-8 overflow-y-auto p-6 sm:p-10 nav:h-screen nav:items-stretch nav:gap-0 nav:p-12 [@media(max-width:899px)_and_(max-height:720px)]:gap-4 [@media(max-width:899px)_and_(max-height:720px)]:py-4">
        <Logo />
        <div className="flex w-full flex-col items-center justify-center nav:items-start">{children}</div>
        <div className="text-[12px] font-medium uppercase tracking-[0.14em] text-muted-2">{t('auth.version')}</div>
      </div>
      <AuthPromoPane />
    </div>
  );
}
